import { render, staticRenderFns } from "./CommunicationPrefTimes.vue?vue&type=template&id=3ec4bc60&scoped=true"
import script from "./CommunicationPrefTimes.vue?vue&type=script&lang=js"
export * from "./CommunicationPrefTimes.vue?vue&type=script&lang=js"
import style0 from "./CommunicationPrefTimes.vue?vue&type=style&index=0&id=3ec4bc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4bc60",
  null
  
)

export default component.exports